import React, { memo, useState } from "react";
import { OrderListprops } from "../../../../Component/Interface/Order";
import { CheckBox, Icon } from "../../../../Component/style/common_style";
import RenderMultiRows2, {
  HeaderRow,
  Row,
  Table,
  TableHeader,
} from "../../../../Component/style/orderTable_style2";
import styled from "styled-components";
import MatchingModal from "../Modal/MatchingModal";
import PayDoneModal from "../Modal/PayDoneModal";

const Order_paydeil = memo(
  ({
    list,
    total,
    selectOrder,
    setSelectOrder,
    modify_memo,
    select_status,
    setSelect_status,
    page,
  }: OrderListprops) => {
    const setting_check_list = (seq: number) => {
      if (select_status !== "") {
        if (
          !window.confirm("모든 주문 선택이 취소됩니다.\n취소하시겠습니까?")
        ) {
          return;
        }
        if (setSelect_status) setSelect_status("");
        return;
      }

      if (!selectOrder || !setSelectOrder) {
        return;
      }
      const copyArr = selectOrder.includes(seq)
        ? selectOrder.filter((item) => item !== seq)
        : [...selectOrder, seq];
      setSelectOrder(copyArr);
    };

    const all_check = () => {
      if (select_status !== "" && setSelect_status) return setSelect_status("");
      if (!setSelectOrder) return;
      if (selectOrder?.length === total) return setSelectOrder([]);

      const orderDetailSeqs = list.flatMap((order) =>
        order.order_details.map((detail) => detail.detail_seq)
      );
      setSelectOrder(orderDetailSeqs);
    };

    const isChecked_all = () => {
      if (select_status !== "") return true;
      if (selectOrder?.length === total && total !== 0) return true;
      return false;
    };
    const isChecked_item = (detail_seq: number) => {
      if (select_status !== "") return true;
      if (selectOrder?.includes(detail_seq)) return true;
      return false;
    };

    // 매칭 모달
    const [visible, setVisible] = useState(false);
    const handleModal = () => {
      setVisible(!visible);
    };

    // 입금정보 모달
    const [payDoneVisible, setPayDoneVisible] = useState(false);
    const handleModal2 = () => {
      setPayDoneVisible(!payDoneVisible);
    };

    return (
      <>
        <TableHeader>
          <span>
            <CheckBox
              type={"checkbox"}
              className="red"
              onClick={all_check}
              checked={isChecked_all()}
              readOnly
            />
          </span>
          {/* {(page === "non-pay" || page === "done-pay") && (
            <HeaderRow $width={8}>입금정보</HeaderRow>
          )} */}
          {/* 입금정보 추가되면 해제 */}
          <HeaderRow $width={8}>주문자</HeaderRow>
          <HeaderRow $width={6}>입금자</HeaderRow>
          <HeaderRow $width={10}>주문일시</HeaderRow>
          <HeaderRow $width={6}>상품 번호</HeaderRow>
          <HeaderRow>품목명</HeaderRow>
          <HeaderRow>옵션</HeaderRow>
          <HeaderRow>단가</HeaderRow>
          <HeaderRow $width={6}>수량</HeaderRow>
          <HeaderRow>총 금액</HeaderRow>
          <HeaderRow $width={6}>택배비</HeaderRow>
          <HeaderRow>총 결제금액</HeaderRow>
          <HeaderRow $width={8}>받는 분</HeaderRow>
          <HeaderRow>받는 분 전화</HeaderRow>
          <HeaderRow $width={7}>받는 분 우편번호</HeaderRow>
          <HeaderRow className="flex3">받는 분 주소</HeaderRow>

          {/* <HeaderRow>운송장번호</HeaderRow> */}
        </TableHeader>

        {list.map((data, idx) => {
          const rowHeight = data.order_details.length || 1;
          const total_payment = data.total_payment.toLocaleString("ko-KR");

          return (
            <Table
              key={idx}
              className={idx % 2 === 0 ? "" : "x2"}
              $height={rowHeight}
            >
              <span>
                <RenderMultiRows2
                  detailData={data.order_details}
                  searchkey={"seq_check"}
                  Component={({ detail_seq }) => (
                    <CheckBox
                      type={"checkbox"}
                      className="red"
                      value={detail_seq}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setting_check_list(Number(e.target.value))
                      }
                      checked={isChecked_item(detail_seq)}
                    />
                  )}
                />
              </span>

              {/* {(page === "non-pay" || page === "done-pay") && (
                <Row $width={8}>
                  {page === "non-pay" && (
                    <MatchingBtn
                      matching={data.matching}
                      onClick={() => {
                        data.matching && handleModal();
                      }}
                    >
                      매칭하기
                    </MatchingBtn>
                  )}
                  {page === "done-pay" && (
                    <PayDoneBtn onClick={handleModal2}>입금정보</PayDoneBtn>
                  )}
                </Row>
              )} */}
              {/* 입금정보 추가되면 해제 */}

              <Row $width={8}>{data.order_name}</Row>
              <Row $width={6}>{data.order_nickname}</Row>

              {[
                { key: "주문일시", width: 10 },
                { key: "상품번호", width: 6 },
                { key: "품목명" },
                { key: "옵션" },
                { key: "단가" },
                { key: "수량", width: 6 },
                { key: "총 금액" },
              ].map(({ key, width }) => (
                <Row key={key} $width={width}>
                  <RenderMultiRows2
                    detailData={data.order_details}
                    searchkey={key}
                  />
                </Row>
              ))}

              <Row $width={6}>{data.delivery_price}</Row>
              <Row>{total_payment}</Row>
              <Row $width={8}>{data.addr_recipient}</Row>
              <Row>{data.addr_phone}</Row>
              <Row $width={7}>{data.addr_num}</Row>
              <Row className="last">{`${data.addr_basic} ${data.addr_detail}`}</Row>

              {/* <Row className="last">
                <RenderMultiRows2
                  detailData={data.order_details}
                  searchkey={"운송장번호"}
                  Component={({ detail_seq }) => (
                    <Icon
                      src={require("../../../../Image/Admin/ic_modi.png")}
                      onClick={() => {
                        const data = window.prompt("운송장번호");
                        if (modify_memo && data) {
                          modify_memo(detail_seq, "delivery_info", data);
                        }
                      }}
                    />
                  )}
                />
              </Row> */}
              <MatchingModal
                visible={visible}
                handleModal={handleModal}
                data={data}
              />
              <PayDoneModal
                visible={payDoneVisible}
                handleModal={handleModal2}
                data={data}
              />
            </Table>
          );
        })}
      </>
    );
  }
);

export default Order_paydeil;

const MatchingBtn = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "matching",
})<{ matching: boolean }>`
  width: 62px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.matching ? "linear-gradient(135deg, #7955f0, #3209b9)" : "#F0F0F0"};
  cursor: pointer;
  border-radius: 8px;
  color: ${(props) => (props.matching ? "white" : "#C6C6C6")};
  font-size: 12px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const PayDoneBtn = styled.div`
  width: 62px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ecf1ff;
  cursor: pointer;
  border-radius: 8px;
  color: #2768ff;
  font-size: 12px;
  font-family: var(--font-Pretendard-SemiBold);
`;
